module.exports = __webpack_public_path__ + "static/media/ne.b7369ec7.svg";